import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake.js';

const DiaryAgendaServicesByProfReportPDF = async (obj) => {
    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const listTipos = JSON.parse(sessionStorage.getItem('centroTipos'));

    let itemBodyFontSize = 7.5;

    console.log('dataToSend', obj);

    let clasifiedServicesLabs = !!obj.reporte ? obj.reporte.filter(serv => (serv.cup_cod.substring(0, 2) !== '89' && serv.cup_cod.substring(0, 2) !== '88') && serv.tipo === 2) : [];
    let clasifiedServicesExams = !!obj.reporte ? obj.reporte.filter(serv => serv.cup_cod.substring(0, 2) !== '90' && (serv.tipo !== 2 || serv.tipo === 1)) : [];
    let totalAmountOfServiceLabs = !!clasifiedServicesLabs ? !!clasifiedServicesLabs.length ? clasifiedServicesLabs.reduce((acc, curr) => acc += curr.cantidad, 0) : 0 : 0;
    let dataToMainTable = obj.classifyServices ? clasifiedServicesExams : obj.reporte;
    let totalAmountOfService = !!dataToMainTable ? !!dataToMainTable.length ? dataToMainTable.reduce((acc, curr) => acc += curr.cantidad, 0) : 0 : 0;

    let bodyTable = [];

    bodyTable.push(
        [{ text: 'Profesional', bold: true, fontSize: 10 }, { text: 'Entidad', bold: true, fontSize: 10 }, { text: 'Actividad', bold: true, fontSize: 10 }, { text: 'Cantidad', bold: true, fontSize: 10 }]
    );
    try {
        for (let k = 0; k < dataToMainTable.length; k++) {
            bodyTable.push([
                { text: "Dr.(a) " + dataToMainTable[k].nombre_profesional, style: 'textStyle' },
                { text: dataToMainTable[k].nombre_entidad, style: 'textStyle' },
                { text: dataToMainTable[k].servicio, style: 'textStyle' },
                { text: dataToMainTable[k].cantidad, style: 'textStyle' },
            ]);
        }
    }
    catch (e) {
        console.log(e);
    }

    let bodyTableLabs = [];

    bodyTableLabs.push(
        [{ text: 'Profesional', bold: true, fontSize: 10 }, { text: 'Entidad', bold: true, fontSize: 10 }, { text: 'Actividad', bold: true, fontSize: 10 }, { text: 'Cantidad', bold: true, fontSize: 10 }]
    );
    try {
        for (let k = 0; k < clasifiedServicesLabs.length; k++) {
            bodyTableLabs.push([
                { text: "Dr.(a) " + clasifiedServicesLabs[k].nombre_profesional, style: 'textStyle' },
                { text: clasifiedServicesLabs[k].nombre_entidad, style: 'textStyle' },
                { text: clasifiedServicesLabs[k].servicio, style: 'textStyle' },
                { text: clasifiedServicesLabs[k].cantidad, style: 'textStyle' },
            ]);
        }
    }
    catch (e) {
        console.log(e);
    }
    const tableAgendaByProfesional = (opt) => {
        try {
            if (!!obj.reporte) {
                if (!!obj.reporte.length) {
                    return {
                        margin: [0, 5, 0, 10],
                        layout: "lightHorizontalLines",
                        table: {
                            widths: ['auto', 'auto', 'auto', '*'],
                            headerRows: 1,
                            body: bodyTable,
                        },
                    };
                }
            }
        } catch (err) {
            return null;
        }
    };

    const tableAgendaByProfesionalLabs = () => {
        try {
            if (!!clasifiedServicesLabs) {
                if (!!clasifiedServicesLabs.length) {
                    return {
                        margin: [0, 5, 0, 10],
                        layout: "lightHorizontalLines",
                        table: {
                            widths: ['auto', 'auto', 'auto', '*'],
                            headerRows: 1,
                            body: bodyTableLabs,
                        },

                    };
                }
            }
        } catch (err) {
            return null;
        }
    };

    pdfMake.tableLayouts = {
        exampleLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 1;
                }
                return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
                return 1;
            },
            hLineColor: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return "black";
                }
                return i === 1 ? "black" : "#aaa";
            },
            fillColor: function (i, node) {
                return i === 0 ? "white" : i % 2 === 0 ? "#e8e8e8" : null;
            },
            paddingLeft: function (i) {
                return i === 0 ? 8 : 8;
            },
            paddingRight: function (i, node) {
                //return i === node.table.widths.length - 1 ? 0 : 8;
                return 3;
            },
            paddingTop: function (i, node) {
                return 3;
            },
            paddingBottom: function (i, node) {
                return 3;
            },

        },
    };

    var docDefinition = {
        pageSize: "LETTER",
        //pageOrientation: listTipos.includes('3') ? "portrait" : "landscape",
        pageOrientation: "landscape",
        /*footer: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: pageSize.width,
                            h: 5,
                        },

                    ],
                }
            ];
        },*/
        /*
        header: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 10,
                            w: pageSize.width,
                            h: 3,
                        },
                    ],
                },
            ];
        },
        */
        content: [
            {
                layout: 'noBorders',
                table: {
                    widths: ['*', 'auto', '*'],
                    body: [
                        [{
                            image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + obj.profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                            fit: [180, 90],
                            alignment: 'left'
                        },
                        {
                            margin: [0, 10, 0, 10],
                            layout: "noBorders",
                            table: {
                                widths: ['*'],
                                headerRows: 1,
                                body: [
                                    [
                                        {
                                            text: obj.title,
                                            bold: true,
                                            width: "auto",
                                            alignment: "center",
                                            lineHeight: 1.2,
                                            fontSize: 13,
                                        }
                                    ],
                                    [
                                        {
                                            text: 'Fecha Inicial:' + obj.fInicial + ' Fecha Final:' + obj.fFinal,
                                            width: "auto",
                                            bold: true,
                                            alignment: "center",
                                            lineHeight: 1.2,
                                            fontSize: 9,
                                        },
                                    ],
                                    [
                                        {
                                            text: 'Fecha Impresión:' + moment(new Date()).format('DD/MM/YYYY'),
                                            width: "auto",
                                            alignment: "center",
                                            lineHeight: 1.2,
                                            fontSize: 7.5,
                                        },
                                    ]
                                ],
                            },
                        },
                        {
                            layout: 'noBorders',
                            margin: [0, 5, 0, 5],
                            table: {
                                widths: ['*'],
                                body: [
                                    [{ text: obj.profile.nombre, style: 'textheadTop' }],
                                    [{ text: 'NIT: : ' + obj.profile.nit, style: 'textheadTop' }],
                                    [{ text: obj.profile.direccion.direccion, style: 'textheadTop' }],
                                    [{ text: obj.profile.email, style: 'textheadTop' }],
                                ],
                            },
                            alignment: 'right'
                        },],
                    ],
                },
            },
            tableAgendaByProfesional(),
            {
                margin: [0, 2, 0, 10],
                layout: {
                    defaultBorder: false,
                },
                table: {
                    widths: ['*', '*', '*', '*'],
                    headerRows: 1,
                    body: [
                        [{ text: '', bold: true, style: 'textStyle', border: [false, true, false, false] }, { text: '', bold: true, style: 'textStyle', border: [false, true, false, false] }, { text: 'Total: ', style: 'textStyle', border: [false, true, false, false], bold: true }, { text: totalAmountOfService, style: 'textStyle', border: [false, true, false, false], bold: true }],
                    ],
                },
            },
            obj.classifyServices ?
            {
                text: "Examenes de Laboratorio",
                bold: true,
                width: "auto",
                alignment: "left",
                lineHeight: 1.2,
                fontSize: 13,
            }: null,
            obj.classifyServices ?
                tableAgendaByProfesionalLabs()
                : null,
            obj.classifyServices ?
                {
                    margin: [0, 2, 0, 10],
                    layout: {
                        defaultBorder: false,
                    },
                    table: {
                        widths: ['*', '*', '*', '*'],
                        headerRows: 1,
                        body: [
                            [{ text: '', bold: true, style: 'textStyle', border: [false, true, false, false] }, { text: '', bold: true, style: 'textStyle', border: [false, true, false, false] }, { text: 'Total: ', style: 'textStyle', border: [false, true, false, false], bold: true }, { text: totalAmountOfServiceLabs, style: 'textStyle', border: [false, true, false, false], bold: true }],
                        ],
                    },
                } : null,
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            tableExample: {
                margin: [0, 5, 0, 0],
                fontSize: itemBodyFontSize
            },
            tableHeader: {
                bold: true,
                fontSize: 9,
                color: "black",
            },
            textStyle: {
                fontSize: 8,
                alignment: 'left',
                font: 'OpenSans'
            },
            texthead: {
                fontSize: 10,
                alignment: 'right',
                font: 'OpenSans'
            },
            textheadTop: {
                fontSize: 9,
                alignment: 'right',
                font: 'OpenSans'
            }
        },
        defaultStyle: {
            columnGap: 15,
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition).open();
    /*  pdfDocGenerator.getDataUrl(function (outDoc) {
         document.getElementById('pdfV').src = outDoc;
     }); */
};

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default DiaryAgendaServicesByProfReportPDF;